<template>
  <div class="edit-content">
    <div id="now-loading">
      <div class="loading-message">
        ロード中です<br />
        しばらくお待ちください
      </div>
    </div>

    <div class="containerWrapper">
      <!-- [ div.container -->
      <div class="container container--edit">
        <!-- 編集画面の上部メニュー -->
        <Header class="header--edit">
          <template #title>家紋作成</template>
          <template #menu>
            <!-- ツールボックス：なし（基本表示） -->
            <div v-if="TOOLBOX_TYPE.NONE == toolboxType">
              <CancelButton class="reselect-img" @click="onClickReselectBtn">
                戻る
              </CancelButton>
              <!-- 〓アカウント切り替え確認のアラートウィンドウが開く〓 -->
              <button
                id="alert_open-twitter"
                class="twitter-icon"
                type="button"
              ></button>
              <!-- 〓 .toolbox--save-load から .is-hidden を削除し、 .is-visible を付与〓 -->
              <Button class="btn-save" @click="onClickShowSaveBtn">保存</Button>
              <!--<form class="form-complete" id="form_complete" action="http://127.0.0.1:8080/kokosuki/image/edit" accept-charset="utf-8" method="post">-->
              <input
                id="form_complete_image"
                name="complete_image"
                value=""
                type="hidden"
              />
              <input
                id="form_edit_data_for_post"
                name="edit_data"
                value=""
                type="hidden"
              />
              <input
                id="form_twitter_screen_name"
                name="twitter_screen_name"
                value="tmp_name"
                type="hidden"
              />
              <!-- 〓編集された画像データを「該当背景画像種別のフレーム画像」「作成日付」「ユーザーアカウント名」と合成して投稿ページへ遷移〓 -->
              <EnterButton class="btn-complete" @click="onClickCompleteBtn">
                完成
              </EnterButton>
            </div>
            <!-- ツールボックス：アイテム追加 -->
            <div v-else-if="TOOLBOX_TYPE.ADD_ITEM == toolboxType">
              <div class="toolbox--menu">
                <button class="btn-close" @click="onClickCloseToolboxBtn">
                  ☓
                </button>
                <span class="toolbox--menu-title">家紋入筆</span>
              </div>
            </div>
            <!-- ツールボックス：セーブ・読み込み -->
            <div v-else-if="TOOLBOX_TYPE.SAVE_AND_LOAD == toolboxType">
              <div class="toolbox--menu">
                <button class="btn-close" @click="onClickCloseToolboxBtn">
                  <!-- 〓 .toolbox--save-load から .is-visible を削除し、 .is-hidden を付与〓 -->
                  ☓
                </button>
                <span class="toolbox--menu-title">保存・読込</span>
              </div>
            </div>
          </template>
        </Header>

        <!-- 編集画面 -->
        <div class="edit-area">
          <p class="item-counter"><span>000</span>&nbsp;/&nbsp;120</p>
          <canvas
            id="edit-object-canvas"
            width="750"
            height="750"
            :data-baseillust-src="canvasImgSrc"
            :data-baseillust-x="trimPoint.x"
            :data-baseillust-y="trimPoint.y"
            :data-baseillust-scale="trimPoint.scale"
            :data-edit-data="JSON.stringify(savedEditData)"
            :data-font="dataFontSrc"
          >
            <img alt="背景" class="canvas-bg" />
          </canvas>

          <canvas
            id="frame-canvas"
            width="807"
            height="997"
            style="display: none"
          >
          </canvas>
        </div>

        <!-- 編集画面の下部メニュー -->
        <Footer class="footer-menu">
          <Button class="footer-btn select-change">
            <div>選択</div>
            <div>切替</div>
          </Button>
          <div class="add-item-container">
            <EnterButton
              class="footer-btn add-item add-item--item"
              @click="onClickAddItemForItem"
            >
              <div>家紋</div>
              <div>入筆</div>
            </EnterButton>
            <!--
            <EnterButton
              class="footer-btn add-item add-item--text"
              @click="onClickAddItemForText"
            >
              <div>文字</div>
              <div>入力</div>
            </EnterButton>
            -->
          </div>
        </Footer>

        <!-- 以下、各作成素材パーツの追加ツールボックスに関する記述 -->

        <!-- [ ツールボックス / アイテム追加 -->
        <div class="toolbox toolbox--add-item is-hidden">
          <div class="toolbox__body toolbox__body--add-item">
            <!-- [ 貼るだけ作成素材 -->
            <div
              class="toolbox-content toolbox-content--add-item toolbox-content--png-item is-select"
            >
              <EnterButton
                class="material-add-btn material-color-add-btn is-hidden"
                @click="onClickAddMaterialBtn"
              >
                追加
              </EnterButton>
              <!-- <div class="tab-menu tab-menu--add-item">
                <button class="tab-menu__item tab-menu__deco" disabled>
                  <img alt="貼るだけ作成素材" src="" />
                </button>
                <button
                  class="tab-menu__item tab-menu__deco"
                  data-target="toolbox-content--svg-item"
                >
                  <img alt="色を変えられる作成素材" src="" />
                </button>
              </div> -->
              <!--  png アイテムのカテゴリ一覧 -->
              <div class="toolbox-content__category">
                <div class="item-category-container">
                  <!--  〓各カテゴリのボタンタップで該当の .item-category に .is-select を付与。同時にカテゴリのデータで .material-parts-container 全体を構築〓
                  最初のカテゴリのみis-select -->
                  <button class="item-category is-select" data-target="1">
                    <img
                      class="item-category-img"
                      alt="家紋アイコン"
                      :src="`/app/assets/img/deco_item/07_svg/thumb/${decoItems[0].id}_${decoItems[0].name}.svg`"
                    />
                  </button>
                  <button class="item-category" data-target="2">
                    <img
                      class="item-category-img"
                      alt="汎用アイコン"
                      src="/app/assets/img/deco_item/heroicons/academic-cap.svg"
                    />
                  </button>
                </div>
              </div>
              <!-- 色変更なしアイテム一覧 -->
              <div class="toolbox-content__item">
                <!--  TODO itemMasterから各タブ種別とその内容をループで取り出したい -->
                <div
                  id="material-parts-container--color-1"
                  class="material-parts-container material-parts-container--item material-parts-container--color"
                >
                  <button
                    v-for="decoItem in decoItems"
                    :key="decoItem.name"
                    class="material-parts material-mono-part"
                    :data-target="decoItem.code"
                    :data-target-id="decoItem.id"
                    @click="addMaterialMono(decoItem.code, decoItem.id)"
                  >
                    <img
                      :src="`/app/assets/img/deco_item/07_svg/thumb/${decoItem.id}_${decoItem.name}.svg`"
                    />
                  </button>
                </div>
                <div
                  id="material-parts-container--color-2"
                  class="material-parts-container material-parts-container--item material-parts-container--color"
                >
                  <!-- TODO addMaterialColorでうまくフォーカスが効かない問題
                  <button
                    v-for="itemHeroIconMasterRecord in itemHeroIconMasterRecords"
                    :key="itemHeroIconMasterRecord.name"
                    class="material-parts material-color-part"
                    :data-target="`/app/assets/img/deco_item/heroicons/${itemHeroIconMasterRecord.name}.svg`"
                    :data-target-id="itemHeroIconMasterRecord.name"
                    @click="
                      addMaterialColor(
                        `/app/assets/img/deco_item/heroicons/${itemHeroIconMasterRecord.name}.svg`,
                        itemHeroIconMasterRecord.name
                      )
                    "
                  > -->
                  <button
                    v-for="itemHeroIconMasterRecord in itemHeroIconMasterRecords"
                    :key="itemHeroIconMasterRecord.name"
                    class="material-parts material-color-part"
                    :data-target="`/app/assets/img/deco_item/heroicons/${itemHeroIconMasterRecord.name}.svg`"
                    :data-target-id="itemHeroIconMasterRecord.name"
                  >
                    <img
                      class="material-part-img"
                      :src="`/app/assets/img/deco_item/heroicons/${itemHeroIconMasterRecord.name}.svg`"
                    />
                  </button>
                </div>
              </div>
            </div>
            <!-- ] 貼るだけ作成素材 -->

            <!-- [ 色を変えられる作成素材
            <div
              class="toolbox-content toolbox-content--add-item toolbox-content--svg-item is-select without-colorchip"
            >
              <EnterButton class="material-add-btn material-color-add-btn is-hidden">
                追加
              </EnterButton>
              作成素材のタブ[
              <div class="tab-menu tab-menu--add-item">
                <button
                  class="tab-menu__item tab-menu__deco"
                  data-target="toolbox-content--png-item"
                >
                  <img alt="貼るだけ作成素材" src="" />
                </button>
                <button class="tab-menu__item tab-menu__deco" disabled>
                  <img alt="色を変えられる作成素材" src="" />
                </button>
              </div>
              ] タブ
              svg アイテム一覧
              <div class="toolbox-content__item toolbox-content__item--svg">
                <div class="material-parts-container material-parts-container--item">
                  <button
                    v-for="decoItem in decoItems"
                    :key="decoItem.name"
                    class="material-parts material-mono-part"
                    :data-target="decoItem.code"
                    :data-target-id="decoItem.id"
                  >
                    <img
                      :src="`/app/assets/img/deco_item/07_svg/thumb/${decoItem.id}_${decoItem.name}.svg`"
                    />
                  </button>
                </div>
              </div>
            </div>
            ] 色を変えられる作成素材 -->
          </div>
        </div>
        <!-- ] ツールボックス / アイテム追加 -->

        <!-- [ ツールボックス / テキスト追加
        <div class="toolbox toolbox--add-text is-hidden">
          <Header class="toolbox__header">
            <button class="btn-close">
              〓 .toolbox--add-text から .is-visible を削除し、 .is-hidden を付与〓
              ☓
            </button>
            <template v-slot:title>文字追加</template>
          </Header>
          <div class="toolbox__body toolbox__body--add-text">
            <div class="toolbox-content toolbox-content--add-text">
              〓プレビュー中のテキストデータを作成素材編集画面に追加〓
              <EnterButton
                class="material-add-btn material-text-add-btn is-hidden"
                data-text-color="ffffff"
                data-border-color="ffffff"
                data-text-align="left"
              >
                追加
              </EnterButton>

              <div class="text-form">
                <p class="text-form__caution">最大15文字×5行</p>
                〓入力した文字をプレビューエリアに差し込み〓
                <textarea
                  class="textarea"
                  name="material-text"
                  wrap="off"
                  placeholder="テキストを入力"
                ></textarea>
                <div class="text-align-container is-left">
                  〓各ボタンタップで該当ボタン以外の disabled を削除、該当ボタンに disabled を付与。同時に、テキストの文字寄せを変更〓
                  <button
                    class="text-align text-align--left"
                    data-target="left"
                    disabled
                  ></button>
                  <button
                    class="text-align text-align--center"
                    data-target="center"
                  ></button>
                  <button
                    class="text-align text-align--right"
                    data-target="right"
                  ></button>
                </div>
              </div>

              <div class="text-color">
                <div
                  class="tab-menu tab-menu--text-color tab-menu--text-color-select"
                >
                  <button
                    class="tab-menu__item tab-menu__text-color tab-menu__item--text is-select"
                    data-target="text-color"
                    disabled
                  ></button>
                  <button
                    class="tab-menu__item tab-menu__text-color tab-menu__item--border is-hidden"
                    data-target="border-color"
                  ></button>
                </div>

                <label class="border-switch">
                  <input
                    class="border-switch__input"
                    type="checkbox"
                    value=""
                  />
                  <span class="border-switch__parts"></span>
                </label>

                <div class="color-select">
                  <div class="colorchip-container">
                    <button
                      id="colorchip-ffffff"
                      class="colorchip"
                      data-target="ffffff"
                    ></button>
                    <button
                      id="colorchip-aaaaaa"
                      class="colorchip"
                      data-target="aaaaaa"
                    ></button>
                    <button
                      id="colorchip-555555"
                      class="colorchip"
                      data-target="555555"
                    ></button>
                    <button
                      id="colorchip-000000"
                      class="colorchip"
                      data-target="000000"
                    ></button>
                    <button
                      id="colorchip-ffc2d5"
                      class="colorchip"
                      data-target="ffc2d5"
                    ></button>
                    <button
                      id="colorchip-ffdfa1"
                      class="colorchip"
                      data-target="ffdfa1"
                    ></button>
                    <button
                      id="colorchip-feff8d"
                      class="colorchip"
                      data-target="feff8d"
                    ></button>
                    <button
                      id="colorchip-aaff56"
                      class="colorchip"
                      data-target="aaff56"
                    ></button>
                    <button
                      id="colorchip-82fff8"
                      class="colorchip"
                      data-target="82fff8"
                    ></button>
                    <button
                      id="colorchip-bdbdff"
                      class="colorchip"
                      data-target="bdbdff"
                    ></button>
                    <button
                      id="colorchip-e1b9ff"
                      class="colorchip"
                      data-target="e1b9ff"
                    ></button>
                    <button
                      id="colorchip-44fdff"
                      class="colorchip"
                      data-target="44fdff"
                    ></button>
                    <button
                      id="colorchip-ff2fee"
                      class="colorchip"
                      data-target="ff2fee"
                    ></button>
                    <button
                      id="colorchip-d8ff00"
                      class="colorchip"
                      data-target="d8ff00"
                    ></button>
                    <button
                      id="colorchip-5aff00"
                      class="colorchip"
                      data-target="5aff00"
                    ></button>
                    <button
                      id="colorchip-ff0000"
                      class="colorchip"
                      data-target="ff0000"
                    ></button>
                    <button
                      id="colorchip-ffa200"
                      class="colorchip"
                      data-target="ffa200"
                    ></button>
                    <button
                      id="colorchip-fcff00"
                      class="colorchip"
                      data-target="fcff00"
                    ></button>
                    <button
                      id="colorchip-22f100"
                      class="colorchip"
                      data-target="22f100"
                    ></button>
                    <button
                      id="colorchip-00bbef"
                      class="colorchip"
                      data-target="00bbef"
                    ></button>
                    <button
                      id="colorchip-3737ff"
                      class="colorchip"
                      data-target="3737ff"
                    ></button>
                    <button
                      id="colorchip-ab2de5"
                      class="colorchip"
                      data-target="ab2de5"
                    ></button>
                    <button
                      id="colorchip-ef8c29"
                      class="colorchip"
                      data-target="ef8c29"
                    ></button>
                    <button
                      id="colorchip-d16a73"
                      class="colorchip"
                      data-target="d16a73"
                    ></button>
                    <button
                      id="colorchip-e2cf9c"
                      class="colorchip"
                      data-target="e2cf9c"
                    ></button>
                    <button
                      id="colorchip-efede7"
                      class="colorchip"
                      data-target="efede7"
                    ></button>
                    <button
                      id="colorchip-6d3f8e"
                      class="colorchip"
                      data-target="6d3f8e"
                    ></button>
                    <button
                      id="colorchip-474878"
                      class="colorchip"
                      data-target="474878"
                    ></button>
                    <button
                      id="colorchip-263b60"
                      class="colorchip"
                      data-target="263b60"
                    ></button>
                    <button
                      id="colorchip-c6a16d"
                      class="colorchip"
                      data-target="c6a16d"
                    ></button>
                    <button
                      id="colorchip-ea3434"
                      class="colorchip"
                      data-target="ea3434"
                    ></button>
                    <button
                      id="colorchip-b72f2f"
                      class="colorchip"
                      data-target="b72f2f"
                    ></button>
                    <button
                      id="colorchip-63d5e0"
                      class="colorchip"
                      data-target="63d5e0"
                    ></button>
                    <button
                      id="colorchip-ffd364"
                      class="colorchip"
                      data-target="ffd364"
                    ></button>
                    <button
                      id="colorchip-db4995"
                      class="colorchip"
                      data-target="db4995"
                    ></button>
                    <button
                      id="colorchip-01c0bb"
                      class="colorchip"
                      data-target="01c0bb"
                    ></button>
                    <button
                      id="colorchip-932828"
                      class="colorchip"
                      data-target="932828"
                    ></button>
                    <button
                      id="colorchip-c81d00"
                      class="colorchip"
                      data-target="c81d00"
                    ></button>
                    <button
                      id="colorchip-4c1717"
                      class="colorchip"
                      data-target="4c1717"
                    ></button>
                    <button
                      id="colorchip-b24661"
                      class="colorchip"
                      data-target="b24661"
                    ></button>
                    <button
                      id="colorchip-90c947"
                      class="colorchip"
                      data-target="90c947"
                    ></button>
                    <button
                      id="colorchip-0eab80"
                      class="colorchip"
                      data-target="0eab80"
                    ></button>
                    <button
                      id="colorchip-7f7f7f"
                      class="colorchip"
                      data-target="7f7f7f"
                    ></button>
                    <button
                      id="colorchip-b7882b"
                      class="colorchip"
                      data-target="b7882b"
                    ></button>
                    <button
                      id="colorchip-f7f2dc"
                      class="colorchip"
                      data-target="f7f2dc"
                    ></button>
                    <button
                      id="colorchip-809920"
                      class="colorchip"
                      data-target="809920"
                    ></button>
                    <button
                      id="colorchip-0e2433"
                      class="colorchip"
                      data-target="0e2433"
                    ></button>
                    <button
                      id="colorchip-cea31a"
                      class="colorchip"
                      data-target="cea31a"
                    ></button>
                    <button
                      id="colorchip-212121"
                      class="colorchip"
                      data-target="212121"
                    ></button>
                    <button
                      id="colorchip-c0b59b"
                      class="colorchip"
                      data-target="c0b59b"
                    ></button>
                    <button
                      id="colorchip-ff0090"
                      class="colorchip"
                      data-target="ff0090"
                    ></button>
                    <button
                      id="colorchip-ff6c00"
                      class="colorchip"
                      data-target="ff6c00"
                    ></button>
                    <button
                      id="colorchip-952eff"
                      class="colorchip"
                      data-target="952eff"
                    ></button>
                    <button
                      id="colorchip-3787ff"
                      class="colorchip"
                      data-target="3787ff"
                    ></button>
                    <button
                      id="colorchip-39597a"
                      class="colorchip"
                      data-target="39597a"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       ] ツールボックス / テキスト追加 -->

        <!-- [ ツールボックス / 作成素材色変更
        <div class="toolbox toolbox--change-material-color is-hidden">
          <header class="toolbox__header">色選択</header>

          <div class="toolbox__body toolbox__body--change-material-color">
            <div class="toolbox-content toolbox-content--change-material-color">
              <EnterButton class="material-add-btn material-mono-add-btn is-hidden">
                追加
              </EnterButton>
              <EnterButton
                class="material-change-color-btn material-change-mono-color-btn is-hidden"
              >
                変更
              </EnterButton>

              <div class="color-select">
                <button class="btn-close color-select__close"></button>
                <div class="colorchip-container">
                  <button
                    id="colorchip-ffffff"
                    class="colorchip"
                    data-target="ffffff"
                  ></button>
                  <button
                    id="colorchip-aaaaaa"
                    class="colorchip"
                    data-target="aaaaaa"
                  ></button>
                  <button
                    id="colorchip-555555"
                    class="colorchip"
                    data-target="555555"
                  ></button>
                  <button
                    id="colorchip-000000"
                    class="colorchip"
                    data-target="000000"
                  ></button>
                  <button
                    id="colorchip-ffc2d5"
                    class="colorchip"
                    data-target="ffc2d5"
                  ></button>
                  <button
                    id="colorchip-ffdfa1"
                    class="colorchip"
                    data-target="ffdfa1"
                  ></button>
                  <button
                    id="colorchip-feff8d"
                    class="colorchip"
                    data-target="feff8d"
                  ></button>
                  <button
                    id="colorchip-aaff56"
                    class="colorchip"
                    data-target="aaff56"
                  ></button>
                  <button
                    id="colorchip-82fff8"
                    class="colorchip"
                    data-target="82fff8"
                  ></button>
                  <button
                    id="colorchip-bdbdff"
                    class="colorchip"
                    data-target="bdbdff"
                  ></button>
                  <button
                    id="colorchip-e1b9ff"
                    class="colorchip"
                    data-target="e1b9ff"
                  ></button>
                  <button
                    id="colorchip-44fdff"
                    class="colorchip"
                    data-target="44fdff"
                  ></button>
                  <button
                    id="colorchip-ff2fee"
                    class="colorchip"
                    data-target="ff2fee"
                  ></button>
                  <button
                    id="colorchip-d8ff00"
                    class="colorchip"
                    data-target="d8ff00"
                  ></button>
                  <button
                    id="colorchip-5aff00"
                    class="colorchip"
                    data-target="5aff00"
                  ></button>
                  <button
                    id="colorchip-ff0000"
                    class="colorchip"
                    data-target="ff0000"
                  ></button>
                  <button
                    id="colorchip-ffa200"
                    class="colorchip"
                    data-target="ffa200"
                  ></button>
                  <button
                    id="colorchip-fcff00"
                    class="colorchip"
                    data-target="fcff00"
                  ></button>
                  <button
                    id="colorchip-22f100"
                    class="colorchip"
                    data-target="22f100"
                  ></button>
                  <button
                    id="colorchip-00bbef"
                    class="colorchip"
                    data-target="00bbef"
                  ></button>
                  <button
                    id="colorchip-3737ff"
                    class="colorchip"
                    data-target="3737ff"
                  ></button>
                  <button
                    id="colorchip-ab2de5"
                    class="colorchip"
                    data-target="ab2de5"
                  ></button>
                  <button
                    id="colorchip-ef8c29"
                    class="colorchip"
                    data-target="ef8c29"
                  ></button>
                  <button
                    id="colorchip-d16a73"
                    class="colorchip"
                    data-target="d16a73"
                  ></button>
                  <button
                    id="colorchip-e2cf9c"
                    class="colorchip"
                    data-target="e2cf9c"
                  ></button>
                  <button
                    id="colorchip-efede7"
                    class="colorchip"
                    data-target="efede7"
                  ></button>
                  <button
                    id="colorchip-6d3f8e"
                    class="colorchip"
                    data-target="6d3f8e"
                  ></button>
                  <button
                    id="colorchip-474878"
                    class="colorchip"
                    data-target="474878"
                  ></button>
                  <button
                    id="colorchip-263b60"
                    class="colorchip"
                    data-target="263b60"
                  ></button>
                  <button
                    id="colorchip-c6a16d"
                    class="colorchip"
                    data-target="c6a16d"
                  ></button>
                  <button
                    id="colorchip-ea3434"
                    class="colorchip"
                    data-target="ea3434"
                  ></button>
                  <button
                    id="colorchip-b72f2f"
                    class="colorchip"
                    data-target="b72f2f"
                  ></button>
                  <button
                    id="colorchip-63d5e0"
                    class="colorchip"
                    data-target="63d5e0"
                  ></button>
                  <button
                    id="colorchip-ffd364"
                    class="colorchip"
                    data-target="ffd364"
                  ></button>
                  <button
                    id="colorchip-db4995"
                    class="colorchip"
                    data-target="db4995"
                  ></button>
                  <button
                    id="colorchip-01c0bb"
                    class="colorchip"
                    data-target="01c0bb"
                  ></button>
                  <button
                    id="colorchip-932828"
                    class="colorchip"
                    data-target="932828"
                  ></button>
                  <button
                    id="colorchip-c81d00"
                    class="colorchip"
                    data-target="c81d00"
                  ></button>
                  <button
                    id="colorchip-4c1717"
                    class="colorchip"
                    data-target="4c1717"
                  ></button>
                  <button
                    id="colorchip-b24661"
                    class="colorchip"
                    data-target="b24661"
                  ></button>
                  <button
                    id="colorchip-90c947"
                    class="colorchip"
                    data-target="90c947"
                  ></button>
                  <button
                    id="colorchip-0eab80"
                    class="colorchip"
                    data-target="0eab80"
                  ></button>
                  <button
                    id="colorchip-7f7f7f"
                    class="colorchip"
                    data-target="7f7f7f"
                  ></button>
                  <button
                    id="colorchip-b7882b"
                    class="colorchip"
                    data-target="b7882b"
                  ></button>
                  <button
                    id="colorchip-f7f2dc"
                    class="colorchip"
                    data-target="f7f2dc"
                  ></button>
                  <button
                    id="colorchip-809920"
                    class="colorchip"
                    data-target="809920"
                  ></button>
                  <button
                    id="colorchip-0e2433"
                    class="colorchip"
                    data-target="0e2433"
                  ></button>
                  <button
                    id="colorchip-cea31a"
                    class="colorchip"
                    data-target="cea31a"
                  ></button>
                  <button
                    id="colorchip-212121"
                    class="colorchip"
                    data-target="212121"
                  ></button>
                  <button
                    id="colorchip-c0b59b"
                    class="colorchip"
                    data-target="c0b59b"
                  ></button>
                  <button
                    id="colorchip-ff0090"
                    class="colorchip"
                    data-target="ff0090"
                  ></button>
                  <button
                    id="colorchip-ff6c00"
                    class="colorchip"
                    data-target="ff6c00"
                  ></button>
                  <button
                    id="colorchip-952eff"
                    class="colorchip"
                    data-target="952eff"
                  ></button>
                  <button
                    id="colorchip-3787ff"
                    class="colorchip"
                    data-target="3787ff"
                  ></button>
                  <button
                    id="colorchip-39597a"
                    class="colorchip"
                    data-target="39597a"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        ] ツールボックス / 作成素材色変更 -->

        <!-- [ ツールボックス / テキスト色変更
        <div class="toolbox toolbox--change-text-color is-hidden">
          <header class="toolbox__header">色選択</header>

          <div class="toolbox__body toolbox__body--change-text-color">
            <div class="toolbox-content toolbox-content--change-text-color">
              〓プレビュー中のテキストデータを作成素材編集画面に追加〓
              <EnterButton
                class="material-change-color-btn material-change-text-color-btn is-hidden"
                data-text-color="ffffff"
                data-border-color="ffffff"
              >
                追加
              </EnterButton>

              <div class="change-text-color-box">
                <div
                  class="tab-menu tab-menu--text-color tab-menu--text-color-change"
                >
                  <button
                    class="tab-menu__item tab-menu__change-text-color tab-menu__item--text is-select"
                    data-target="text-color"
                    disabled
                  ></button>
                  <button
                    class="tab-menu__item tab-menu__change-text-color tab-menu__item--border is-hidden"
                    data-target="border-color"
                  ></button>
                </div>
                <div class="color-select">
                  <button class="btn-close color-select__close"></button>
                  <div class="colorchip-container">
                    <button
                      id="colorchip-ffffff"
                      class="colorchip"
                      data-target="ffffff"
                    ></button>
                    <button
                      id="colorchip-aaaaaa"
                      class="colorchip"
                      data-target="aaaaaa"
                    ></button>
                    <button
                      id="colorchip-555555"
                      class="colorchip"
                      data-target="555555"
                    ></button>
                    <button
                      id="colorchip-000000"
                      class="colorchip"
                      data-target="000000"
                    ></button>
                    <button
                      id="colorchip-ffc2d5"
                      class="colorchip"
                      data-target="ffc2d5"
                    ></button>
                    <button
                      id="colorchip-ffdfa1"
                      class="colorchip"
                      data-target="ffdfa1"
                    ></button>
                    <button
                      id="colorchip-feff8d"
                      class="colorchip"
                      data-target="feff8d"
                    ></button>
                    <button
                      id="colorchip-aaff56"
                      class="colorchip"
                      data-target="aaff56"
                    ></button>
                    <button
                      id="colorchip-82fff8"
                      class="colorchip"
                      data-target="82fff8"
                    ></button>
                    <button
                      id="colorchip-bdbdff"
                      class="colorchip"
                      data-target="bdbdff"
                    ></button>
                    <button
                      id="colorchip-e1b9ff"
                      class="colorchip"
                      data-target="e1b9ff"
                    ></button>
                    <button
                      id="colorchip-44fdff"
                      class="colorchip"
                      data-target="44fdff"
                    ></button>
                    <button
                      id="colorchip-ff2fee"
                      class="colorchip"
                      data-target="ff2fee"
                    ></button>
                    <button
                      id="colorchip-d8ff00"
                      class="colorchip"
                      data-target="d8ff00"
                    ></button>
                    <button
                      id="colorchip-5aff00"
                      class="colorchip"
                      data-target="5aff00"
                    ></button>
                    <button
                      id="colorchip-ff0000"
                      class="colorchip"
                      data-target="ff0000"
                    ></button>
                    <button
                      id="colorchip-ffa200"
                      class="colorchip"
                      data-target="ffa200"
                    ></button>
                    <button
                      id="colorchip-fcff00"
                      class="colorchip"
                      data-target="fcff00"
                    ></button>
                    <button
                      id="colorchip-22f100"
                      class="colorchip"
                      data-target="22f100"
                    ></button>
                    <button
                      id="colorchip-00bbef"
                      class="colorchip"
                      data-target="00bbef"
                    ></button>
                    <button
                      id="colorchip-3737ff"
                      class="colorchip"
                      data-target="3737ff"
                    ></button>
                    <button
                      id="colorchip-ab2de5"
                      class="colorchip"
                      data-target="ab2de5"
                    ></button>
                    <button
                      id="colorchip-ef8c29"
                      class="colorchip"
                      data-target="ef8c29"
                    ></button>
                    <button
                      id="colorchip-d16a73"
                      class="colorchip"
                      data-target="d16a73"
                    ></button>
                    <button
                      id="colorchip-e2cf9c"
                      class="colorchip"
                      data-target="e2cf9c"
                    ></button>
                    <button
                      id="colorchip-efede7"
                      class="colorchip"
                      data-target="efede7"
                    ></button>
                    <button
                      id="colorchip-6d3f8e"
                      class="colorchip"
                      data-target="6d3f8e"
                    ></button>
                    <button
                      id="colorchip-474878"
                      class="colorchip"
                      data-target="474878"
                    ></button>
                    <button
                      id="colorchip-263b60"
                      class="colorchip"
                      data-target="263b60"
                    ></button>
                    <button
                      id="colorchip-c6a16d"
                      class="colorchip"
                      data-target="c6a16d"
                    ></button>
                    <button
                      id="colorchip-ea3434"
                      class="colorchip"
                      data-target="ea3434"
                    ></button>
                    <button
                      id="colorchip-b72f2f"
                      class="colorchip"
                      data-target="b72f2f"
                    ></button>
                    <button
                      id="colorchip-63d5e0"
                      class="colorchip"
                      data-target="63d5e0"
                    ></button>
                    <button
                      id="colorchip-ffd364"
                      class="colorchip"
                      data-target="ffd364"
                    ></button>
                    <button
                      id="colorchip-db4995"
                      class="colorchip"
                      data-target="db4995"
                    ></button>
                    <button
                      id="colorchip-01c0bb"
                      class="colorchip"
                      data-target="01c0bb"
                    ></button>
                    <button
                      id="colorchip-932828"
                      class="colorchip"
                      data-target="932828"
                    ></button>
                    <button
                      id="colorchip-c81d00"
                      class="colorchip"
                      data-target="c81d00"
                    ></button>
                    <button
                      id="colorchip-4c1717"
                      class="colorchip"
                      data-target="4c1717"
                    ></button>
                    <button
                      id="colorchip-b24661"
                      class="colorchip"
                      data-target="b24661"
                    ></button>
                    <button
                      id="colorchip-90c947"
                      class="colorchip"
                      data-target="90c947"
                    ></button>
                    <button
                      id="colorchip-0eab80"
                      class="colorchip"
                      data-target="0eab80"
                    ></button>
                    <button
                      id="colorchip-7f7f7f"
                      class="colorchip"
                      data-target="7f7f7f"
                    ></button>
                    <button
                      id="colorchip-b7882b"
                      class="colorchip"
                      data-target="b7882b"
                    ></button>
                    <button
                      id="colorchip-f7f2dc"
                      class="colorchip"
                      data-target="f7f2dc"
                    ></button>
                    <button
                      id="colorchip-809920"
                      class="colorchip"
                      data-target="809920"
                    ></button>
                    <button
                      id="colorchip-0e2433"
                      class="colorchip"
                      data-target="0e2433"
                    ></button>
                    <button
                      id="colorchip-cea31a"
                      class="colorchip"
                      data-target="cea31a"
                    ></button>
                    <button
                      id="colorchip-212121"
                      class="colorchip"
                      data-target="212121"
                    ></button>
                    <button
                      id="colorchip-c0b59b"
                      class="colorchip"
                      data-target="c0b59b"
                    ></button>
                    <button
                      id="colorchip-ff0090"
                      class="colorchip"
                      data-target="ff0090"
                    ></button>
                    <button
                      id="colorchip-ff6c00"
                      class="colorchip"
                      data-target="ff6c00"
                    ></button>
                    <button
                      id="colorchip-952eff"
                      class="colorchip"
                      data-target="952eff"
                    ></button>
                    <button
                      id="colorchip-3787ff"
                      class="colorchip"
                      data-target="3787ff"
                    ></button>
                    <button
                      id="colorchip-39597a"
                      class="colorchip"
                      data-target="39597a"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        ] ツールボックス / テキスト色変更 -->

        <!-- [ ツールボックス / セーブ・ロード -->
        <div class="toolbox toolbox--save-load is-hidden">
          <div class="toolbox__save-load">
            <div class="save-image">
              <div class="save-image__title">現在保存されている画像</div>
              <div class="save-image__img">
                <canvas
                  v-if="savedEditData"
                  id="save-image-canvas"
                  width="750"
                  height="750"
                  :data-baseillust-src="canvasImgSrc"
                  :data-baseillust-x="trimPoint.x"
                  :data-baseillust-y="trimPoint.y"
                  :data-baseillust-scale="trimPoint.scale"
                  :data-edit-data="JSON.stringify(savedEditData)"
                >
                </canvas>
                <canvas
                  v-else
                  id="save-image-canvas"
                  width="750"
                  height="750"
                  style="display: none"
                >
                </canvas>
              </div>
            </div>
            <div class="action-btn-container">
              <EnterButton
                class="action-btn action-btn--save"
                @click="onClickSaveBtn"
              >
                保存
              </EnterButton>
              <EnterButton
                class="action-btn action-btn--load"
                @click="onClickLoadBtn"
              >
                読込
              </EnterButton>
            </div>
          </div>
        </div>
        <!-- ] ツールボックス / セーブ・ロード -->
      </div>
      <!-- ] div.container -->
      <div id="alert-save" class="alert-container is-hidden">
        <!-- セーブ時の上書き確認 -->
        <Alert
          :ng-text="'キャンセル'"
          :on-cick-ng="onClickSaveNgBtn"
          :ok-text="'OK'"
          :on-click-ok="onClickSaveOkBtn"
        >
          セーブ済みのデータを<br />上書きしますか？
        </Alert>
      </div>
      <div id="alert-load" class="alert-container is-hidden">
        <!-- ロード時の編集中データ破棄確認 -->
        <Alert
          :ng-text="'キャンセル'"
          :on-click-ng="onClickLoadNgBtn"
          :ok-text="'OK'"
          :on-click-ok="onClickLoadOkBtn"
        >
          編集中のデータを破棄して<br />データをロードしますか？
        </Alert>
      </div>
      <div id="alert-leave" class="alert-container is-hidden">
        <!-- ロード時の編集中データ破棄確認 -->
        <Alert
          :ng-text="'キャンセル'"
          :on-click-ng="onClickLeaveNgBtn"
          :ok-text="'OK'"
          :on-click-ok="onClickLeaveOkBtn"
        >
          編集中のデータを破棄して<br />よろしいですか？
        </Alert>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  onUnmounted,
  ref,
} from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import Edit from "@/javascripts/image/edit";
import MaterialItemMaster from "@/masters/material-item-master";
import ItemMaster from "@/masters/item-master";
import EnterButton from "@/components/EnterButton.vue";
import CancelButton from "@/components/CancelButton.vue";
import Button from "@/components/Button.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Alert from "@/components/Alert.vue";

export default defineComponent({
  name: "Edit",
  components: {
    Button,
    EnterButton,
    CancelButton,
    Header,
    Footer,
    Alert,
  },
  setup() {
    const router = useRouter();
    const toSelect = () => router.push({ name: "select" });
    const toWrite = () => router.push({ name: "write" });
    const reload = () => router.go(0);

    const edit = new Edit();

    const { imageEditor } = useGlobalStore();
    const selectedImage = imageEditor.selectedImage;
    if (!selectedImage) {
      toSelect();
      return;
    }
    let canvasImgSrc = "";
    if (imageEditor.isSelectedImageUploaded()) {
      // アップロード画像を使用する場合
      canvasImgSrc = selectedImage.src as string;
    } else {
      // 選択画像を使用する場合
      canvasImgSrc = "/app/assets/img/base_illust/original/";
      canvasImgSrc += selectedImage.fileName;
    }
    const trimPoint = imageEditor.trimPoint;
    const savedEditData = imageEditor.editData;

    const dataFontSrc = "/app/assets/css/image/icomoon-font.css";

    const decoItems = MaterialItemMaster.records;
    const itemHeroIconMasterRecords = ItemMaster.itemHeroIconMasterRecords;

    // ツールボックスの種別
    const TOOLBOX_TYPE = {
      NONE: "none",
      ADD_ITEM: "add-item", // セレクタのclass名に依存
      SAVE_AND_LOAD: "save-load", // セレクタのclass名に依存
    } as const;
    type ToolboxType = typeof TOOLBOX_TYPE[keyof typeof TOOLBOX_TYPE]; // 'None'|'AddItem'|'SaveAndLoad',

    const toolboxType = ref<ToolboxType>(TOOLBOX_TYPE.NONE);

    onMounted(() => {
      edit.setupEditView();
      edit.setupViewMaterial();
      edit.setupViewText();
      edit.setupViewCommon();
    });

    onBeforeUnmount(() => {
      edit.onBeforeUnmount();
    });

    onUnmounted(() => {});

    function onClickReselectBtn() {
      if (edit.is_saved()) {
        toSelect();
        return;
      }
      edit.showAlertLeave();
    }

    function onClickLeaveOkBtn() {
      imageEditor.resetImage();
      toSelect();
    }

    function onClickLeaveNgBtn() {
      edit.closeAlertLeave();
    }

    function onClickShowSaveBtn() {
      updateCurrentToolboxType(TOOLBOX_TYPE.SAVE_AND_LOAD);
      edit.showToolboxSaveOrLoad();
    }

    function onClickSaveBtn() {
      if (imageEditor.editData) {
        // 保存データがあればアラート
        edit.showAlertSave();
        return;
      }

      saveAndReload();
    }

    function onClickSaveOkBtn() {
      edit.closeAlertSave();
      saveAndReload();
    }

    function onClickSaveNgBtn() {
      edit.closeAlertSave();
    }

    function onClickLoadBtn() {
      if (!edit.is_saved()) {
        edit.showAlertLoad();
        return;
      }

      reload();
    }

    function onClickLoadOkBtn() {
      // edit.barrage_prevent_all();
      reload();
    }

    function onClickLoadNgBtn() {
      edit.closeAlertLoad();
    }

    function onClickAddItemForItem() {
      updateCurrentToolboxType(TOOLBOX_TYPE.ADD_ITEM);
      edit.showToolboxAddItemForItem();
    }

    // function onClickAddItemForText() {
    //   edit.showToolboxAddItemForText();
    // }

    function onClickCompleteBtn() {
      // canvas側の更新
      edit.completeEdit();

      // store側への画像保存
      const completedImage = edit.getCompletedImage();
      imageEditor.completeEditing(completedImage);

      // store側への編集情報保存
      save();

      // 遷移
      toWrite();
    }

    function onClickAddMaterialBtn() {
      Edit.addMaterial();
      closeToolbox();
    }

    function updateCurrentToolboxType(type: ToolboxType) {
      toolboxType.value = type;
    }

    function onClickCloseToolboxBtn() {
      closeToolbox();
    }

    function closeToolbox() {
      edit.closeToolboxByType(toolboxType.value);
      updateCurrentToolboxType(TOOLBOX_TYPE.NONE);
    }

    function addMaterialMono(charCode: string, materialId: number) {
      edit.addMaterialMono(charCode, materialId);
      closeToolbox();
    }

    function addMaterialColor(imageSrc: string, materialId: number) {
      edit.addMaterialColor(imageSrc, materialId);
      closeToolbox();
    }

    function save(): boolean {
      const editData = edit.getEditData();
      if (!editData) {
        return false;
      }
      imageEditor.saveEditData(editData);
      return true;
    }

    function saveAndReload() {
      save();
      reload();
    }

    return {
      toSelect,
      canvasImgSrc,
      trimPoint,
      savedEditData,
      dataFontSrc,
      decoItems,
      addMaterialMono,
      addMaterialColor,
      TOOLBOX_TYPE,
      toolboxType,
      itemHeroIconMasterRecords,
      onClickReselectBtn,
      onClickLeaveOkBtn,
      onClickLeaveNgBtn,
      onClickShowSaveBtn,
      onClickSaveBtn,
      onClickSaveOkBtn,
      onClickSaveNgBtn,
      onClickLoadBtn,
      onClickLoadOkBtn,
      onClickLoadNgBtn,
      onClickAddItemForItem,
      //onClickAddItemForText,
      onClickCompleteBtn,
      onClickAddMaterialBtn,
      onClickCloseToolboxBtn,
    };
  },
});
</script>

<style scoped>
@import "/app/assets/css/style.css";
.header--edit {
  height: 160px;
}
.header-btn {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.footer-btn {
  border-radius: 16px;
  width: 320px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.btn-close {
  color: #ffffff;
  font-size: 4rem;
}
.save-image__title {
  color: #ffffff;
  font-family: "Sawarabi Mincho", sans-serif;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25),
    0px 4px 4px rgba(0, 0, 0, 0.25);
  font-size: 3rem;
  margin: 4rem auto;
}
.toolbox--menu {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center; /* 横方向中央揃え（Safari用） */
  justify-content: center; /* 横方向中央揃え */
  height: 100%;
}
.toolbox--menu-title {
  color: #ffffff;
  font-size: 3rem;
  text-align: center;
  font-family: "Sawarabi Mincho", sans-serif;
  text-shadow: 2px 2px 4px #666666;
  margin: auto;
  padding-top: 3rem;
}
.item-category-img {
  width: 5rem;
}
.material-part-img {
  width: 15rem;
}
</style>
